import PropTypes from 'prop-types';
import React from 'react';
import lazyLoadEnhancer from 'decorators/lazyLoad';
import { CoreImage } from 'components/core/library/image';

function Image({
	alt, className, src, flexImage, role, titleIcon, height, width, onClick, fetchPriority, lazyLoad, ariaHidden
}) {
	return (
		<CoreImage
			alt={alt}
			src={src}
			role={role}
			flexImage={flexImage}
			titleIcon={titleIcon}
			className={className}
			height={height}
			onClick={onClick}
			width={width}
			fetchPriority={fetchPriority}
			loading={fetchPriority === 'high' || lazyLoad === false ? undefined : 'lazy'}
			aria-hidden={ariaHidden}
		/>
	);
}

Image.propTypes = {
	/** The alt tag for the image */
	alt: PropTypes.string,
	/** The path to the image source */
	src: PropTypes.string.isRequired,
	/** transforms the image into a background that is set to cover the container */
	flexImage: PropTypes.bool,
	/** optional image class name */
	className: PropTypes.string,
	/** Make image vertically centered with text with right margin */
	titleIcon: PropTypes.bool,
	/** accessibility role */
	role: PropTypes.string,
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClick: PropTypes.func,
	/** fetchpriority hint for the browser (high, low, auto) */
	fetchPriority: PropTypes.oneOf(['high', 'low', 'auto']),
	/** whether to lazy-load the image (maps to loading="lazy") */
	lazyLoad: PropTypes.bool,
	/** hide image from assistive technology */
	ariaHidden: PropTypes.bool,
};

const LazyImage = lazyLoadEnhancer(Image);

function EnhancedImage({ lazyLoad = true, ...props }) {
	if (lazyLoad) return <LazyImage {...props} />;
	return <Image {...props} />;
}

EnhancedImage.propTypes = {
	/** whether to lazy-load the image (maps to loading="lazy") */
	lazyLoad: PropTypes.bool,
};

export default EnhancedImage;
